import { Component, Input, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';

@Component({
  selector: 'app-account-verification',
  templateUrl: './account-verification.component.html',
  styleUrls: ['./account-verification.component.scss'],
})
export class AccountVerificationComponent implements OnInit {
  @Input() fundingSourceCode: string;

  @Input() hasAgreement: boolean;

  @Input() completedAndVerified: boolean;

  /**
   *Control variable to indicate whether the user is auto approved and as such should see a different variant of the account
   * verification modal.
   */
  isAutoApproved = false;

  constructor(
    public modalCtrl: ModalController,
    private navCtrl: NavController,
  ) {}

  ngOnInit(): void {
    this.isAutoApproved =
      this.completedAndVerified &&
      (this.fundingSourceCode === 'ndis_plan_managed' || this.fundingSourceCode === 'home_care_package');
  }

  /**
   * Redirect to the clients account or to the search workers page.
   */
  redirect(): void {
    this.modalCtrl.dismiss();

    if (this.hasAgreement || this.isAutoApproved) {
      this.navCtrl.navigateForward('/client-account');
    } else {
      this.navCtrl.navigateForward('/search/triage');
    }
  }

  /**
   * Sends the client back to the dashboard.
   */
  goDashboard(): void {
    this.modalCtrl.dismiss();
    this.navCtrl.navigateForward('/home');
  }
}
